import { render, staticRenderFns } from "./PayrollAssessmentSources.vue?vue&type=template&id=4abb3d72&scoped=true&"
import script from "./PayrollAssessmentSources.vue?vue&type=script&lang=js&"
export * from "./PayrollAssessmentSources.vue?vue&type=script&lang=js&"
import style0 from "./PayrollAssessmentSources.vue?vue&type=style&index=0&id=4abb3d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abb3d72",
  null
  
)

export default component.exports